import { render, staticRenderFns } from "./DefaultEmailConfirmation.vue?vue&type=template&id=2c81f6c5&lang=pug&"
import script from "./DefaultEmailConfirmation.vue?vue&type=script&lang=ts&"
export * from "./DefaultEmailConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports